import { selectTV } from './select.styles.esm.js';

var selectVariant = Object.keys(selectTV.variants.variant);
var selectLayoutList = Object.keys(selectTV.variants.layout);
function isSingleSelectValue(_source, multiple) {
  return !multiple;
}
function isMultiSelectValue(_source, multiple) {
  return !!multiple;
}

export { isMultiSelectValue, isSingleSelectValue, selectLayoutList, selectVariant };
//# sourceMappingURL=types.esm.js.map
